import store from "../store";

const toggle = {
  bind: function(el, { modifiers, value }) {
    const type = Object.keys(modifiers)[0] || "button";
    const data =
      typeof value === "object"
        ? { id: value.id, initial: value.initial || false }
        : { id: value, initial: false };

    switch (type) {
      case "button":
        store.dispatch("setGlobalToggle", { key: data.id, value: data.initial });
        el.addEventListener("click", function(e) {
          e.preventDefault();
          store.dispatch("setGlobalToggle", {
            key: data.id,
            value: !store.state.global.globalToggles[data.id],
          });
        });
        break;
      case "checkbox":
        store.dispatch("setGlobalToggle", { key: data.id, value: el.checked });
        el.addEventListener("change", function() {
          store.dispatch("setGlobalToggle", { key: data.id, value: el.checked });
        });
        break;
    }
  },
};

export default { toggle };
